import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greenMui, greyMui, rydeColors } from "@ryde/theme";

export const RideWaitingListPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-waiting-list-panel",
  className: "RideWaitingListPanel",
})`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid ${rydeColors.whiteButtonBorder};

  .RideWaitingListPanel-Header {
    border-bottom: 1px solid ${blueGreyMui._50};
    display: flex;
    align-items: center;
    gap: 12px;
    padding-block: 10px;
  }

  .RideWaitingListPanel-HeaderIcon {
    display: inline-flex;
    align-items: center;
    color: ${rydeColors.grey};
  }

  .RideWaitingListPanel-HeaderTitle {
    font-weight: 600;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      display: inline-block;
      width: 2px;
      height: 1.1em;
      background: ${rydeColors.black};
      margin-inline: 8px;
    }
  }

  .RideWaitingListPanel-Vacancy {
    display: inline-flex;
    align-items: center;
  }

  .RideWaitingListPanel-Chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 12px;
    line-height: 18px;
    color: ${rydeColors.white};
    margin-inline-start: 6px;
  }

  .RideWaitingListPanel-Chip--green {
    background-color: ${greenMui.A700};
  }

  .RideWaitingListPanel-Chip--red {
    background-color: ${rydeColors.brandRed};
  }

  .RideWaitingListPanel-ChipValue {
    font-weight: 700;
  }

  .RideWaitingListPanel-Rows {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .RideWaitingListPanel-Row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 6px;
    border-bottom: 1px solid ${blueGreyMui._50};
  }

  .RideWaitingListPanel-Row--removed .RideWaitingListPanel-Name {
    color: ${greyMui._500};
    text-decoration: line-through;
  }

  .RideWaitingListPanel-Send {
    display: inline-flex;
    align-items: center;
    color: ${greyMui._500};

    .RideWaitingListPanel-SendIcon {
      transform: rotate(-45deg);
    }
  }

  .RideWaitingListPanel-Send--sent {
    color: ${greenMui.A700};
  }

  .RideWaitingListPanel-Send--clickable {
    cursor: pointer;
  }

  .RideWaitingListPanel-Name {
    flex: 1;
  }

  .RideWaitingListPanel-DeleteIcon {
  }

  .RideWaitingListPanel-Empty {
    color: ${greyMui._600};
    font-size: 12px;
    padding: 4px 6px;
  }
`;
